"use client"

import React, { useRef } from 'react'
import LevelUpAndTrustSection from '../../components/LevelUpAndTrustSection/LevelUpAndTrustSection'
import ResourcesSection from '../../components/ResourcesSection/ResourcesSection'
import InfoBox from '../../components/InfoBox/InfoBox'
import { motion, useInView } from "framer-motion";
import Button from '../../components/global-component/DatasheetButtons'

function PenetrationTesting({ blok }) {

  const levelUpRef = useRef(null);


  const handleScrollToLevelUp = () => {
    levelUpRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);
  const ref9 = useRef(null);

  const isInView1 = useInView(ref1, { once: true, margin: "-100px" });
  const isInView2 = useInView(ref2, { once: true, margin: "-100px" });
  const isInView3 = useInView(ref3, { once: true, margin: "-100px" });
  const isInView4 = useInView(ref4, { once: true, margin: "-100px" });
  const isInView5 = useInView(ref5, { once: true, margin: "-100px" });
  const isInView6 = useInView(ref6, { once: true, margin: "-100px" });
  const isInView7 = useInView(ref7, { once: true, margin: "-100px" });
  const isInView8 = useInView(ref8, { once: true, margin: "-100px" });

  const handleDashboardClick = () => {
    window.open(blok?.DatasheetCta?.[0]?.asset?.filename, "_blank");
  };
  return (
    <div className="m-auto  w-full">
      <div
        className="bg-asmPageTopBG bg-cover pb-5"
        style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "center", // Center the background image
          backgroundRepeat: "repeat", // Prevent repeating the background
          margin: "auto",
        }}
      >
        <div className="relative min-h-full flex flex-col items-center py-8 max-w-[1920px] m-auto">
          {/* Header Section */}
          <div className="font-aileron pt-32 pb-14 lg:pt-32 lg:pb-32 text-center font-bold">
            <h2 className="bg-custom-radial bg-clip-text text-transparent text-[48px]  lg:text-[80px]">
              {blok.titleText1}
            </h2>
            <div className="mt-4 w-[90%] m-auto text-[20px] lg:text-[32px] font-normal">
              {blok.titleText2}
            </div>
            <div className="mt-6 flex justify-center gap-6">
              <button
                onClick={handleScrollToLevelUp}
                className="font-aileron text-[16px] lg:text-[24px] font-normal bg-[#5A27E7] text-white px-6
                   py-2 rounded-[4px] hover:bg-[#483889] lg:w-[255px] lg:h-[64px]"
              >
                {blok.btnText1}
              </button>
            </div>
          </div>
        </div>
        <div className="max-w-[1200px] w-full mx-auto px-4">
          <div className="lg:flex justify-center gap-[80px] max-w-7xl mx-auto z-20 mb-40">
            <div ref={ref1} className="w-full max-w-lg">
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={isInView1 ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="lg:w-[523px] lg:h-[415px] w-[300px] flex justify-center items-center mx-auto pb-14 lg:pb-0 lg:mx-0"
              >
                <img src={blok.mainImage1.filename} />
              </motion.div>
            </div>

            <div className="flex-1 text-center lg:text-start">
              <h2 className="font-aileron text-[28px] lg:text-[48px] !font-bold bg-custom-radial bg-clip-text text-transparent mb-4">
                {blok.contentText1}
              </h2>
              <p className="font-aileron text-[16px] lg:text-[18px] mb-6 w-[90%] mx-auto lg:mx-0">
                {blok.contentText2}
              </p>
              <p className="font-aileron text-[16px] lg:text-[18px] mb-6 w-[90%] mx-auto lg:mx-0">
                {blok.contentText3}
              </p>
              <div className="flex justify-center items-center lg:justify-start">
                <Button title={blok?.DatasheetCta?.[0]?.text} onClick={handleDashboardClick} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-useCaseBottomBG bg-cover bg-bottom">
        <div
          style={{
            backgroundSize: "cover", // Ensure the image covers the entire section
            backgroundPosition: "center", // Center the background image
            backgroundRepeat: "no-repeat", // Prevent repeating the background
            // maxWidth: 1920,
            margin: "auto",
          }} className='max-w-7xl'
        >
          <div className="xl:flex justify-center relative -mt-24 xl:mt-0">
            <img src={"/images/PTTIME.png"} className="xl:block hidden w-[74%]" />
            <motion.div
              ref={ref2}
              initial={{ opacity: 0, x: -100 }}
              animate={isInView2 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="xl:absolute left-[50%] xl:mt-[160px]"
            >
              <p className="bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] lg:text-[38px] text-[#49378F] font-bold text-center xl:text-start mb-4 lg:mb-0">
                {blok.contentText4}
              </p>
              <p className="font-lato text-[18px] mx-auto text-center xl:text-start lg:mx-0 px-6 xl:px-0">
                {blok.contentText5}
              </p>
            </motion.div>
            <motion.div
              ref={ref3}
              initial={{ opacity: 0, x: 100 }}
              animate={isInView3 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="xl:absolute right-[55%] xl:top-[530px] mt-10 lg:text-end xl:w-[45%]"
            >
              <p className="bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] lg:text-[38px] text-[#49378F] font-bold text-center xl:text-end mb-4 lg:mb-0">
                {blok.contentText6}
              </p>
              <p className="font-lato text-[18px] xl:text-end mx-auto lg:mx-0 text-center px-6 xl:px-0">
                {blok.contentText7}
              </p>
            </motion.div>
            <motion.div
              ref={ref4}
              initial={{ opacity: 0, x: -100 }}
              animate={isInView4 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="xl:absolute top-0  left-[50%] xl:mt-[930px] mt-10"
            >
              <p className="bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] lg:text-[38px] text-[#49378F] font-bold text-center xl:text-start mb-4 lg:mb-0 px-6 xl:px-0">
                {blok.contentText8}
              </p>
              <p className="font-lato text-[18px] mx-auto lg:mx-0 text-center xl:text-start px-6 xl:px-0">
                {blok.contentText9}
              </p>
            </motion.div>
          </div>
          <div className="relative min-h-full flex flex-col items-center py-8 max-w-[1920px] m-auto lg:-mt-20 -mt-24">
            {/* Header Section */}
            <div className="font-aileron py-20 mt-10 text-center font-bold">
              <h4 className="bg-custom-radial bg-clip-text text-transparent text-[28px] lg:text-[48px] px-6 xl:px-0 ">
                {blok.contentText10}
              </h4>
              <div className="mt-4 text-[18px] font-normal font-lato w-[90%] xl:w-[57%] m-auto">
                {blok.contentText11}
              </div>
              <div ref={ref5} className="mt-6 flex justify-center gap-6">
                <motion.div
                  initial={{ opacity: 0, x: -100 }}
                  animate={isInView5 ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className="lg:w-[878px] lg:h-[583px] w-[380px] flex justify-center items-center px-6 xl:px-0"
                >
                  <img src={blok.contentImage1.filename} />
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center text-center justify-center lg:mb-10">
        <div className="lg:mb-10 w-full  max-w-7xl">
          <div className="flex justify-center mb-10">
            <h6 className="font-aileron bg-custom-radial bg-clip-text text-transparent text-[28px] lg:mt-20 lg:mt-0 lg:text-[48px] font-bold px-6 xl:px-0">
              {blok.contentText12}
            </h6>
          </div>
          <div
            ref={ref6}
            className="grid space-y-10 sm:space-y-0 xl:grid-cols-3 w-[88%] m-auto lg:w-full gap-4 md:gap-[50px] px-0"
          >
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={isInView6 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50"
            >
              {/* Inner content div */}
              <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center  p-4 py-10">
                <img src={blok.contentImage2.filename} className="w-[100px] h-[100px]" />
                <p className="font-lato text-[24px] text-[#49378F] font-bold mb-2 ">
                  {blok.contentText13}
                </p>
                <p className="text-[18px] font-lato w-[80%]">
                  {blok.contentText14}
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={isInView6 ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50"
            >
              {/* Inner content div */}
              <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center  p-4 py-10">
                <img src={blok.contentImage3.filename} className="w-[100px] h-[100px]" />
                <p className="font-lato text-[24px] text-[#49378F] font-bold w-[80%] mb-2">
                  {blok.contentText15}
                </p>
                <p className="text-[18px] font-lato w-[80%]">
                  {blok.contentText16}
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 100 }}
              animate={isInView6 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="relative flex-1 p-[4px] rounded-lg bg-gradient-to-b from-[#D259A6]/80 to-[#48398C]/50"
            >
              {/* Inner content div */}
              <div className="h-full w-full bg-ASMBenefitsBg rounded-lg flex flex-col justify-center items-center text-center  p-4 py-10">
                <img src={blok.contentImage4.filename} className="w-[100px] h-[100px]" />
                <p className="font-lato text-[24px] text-[#49378F] font-bold mb-2">
                  {blok.contentText17}
                </p>
                <p className="text-[18px] font-lato w-[80%]">
                  {blok.contentText18}
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <div
        className="bg-asmPageBottomBG bg-cover flex flex-col items-center"
        style={{
          backgroundSize: "cover", // Ensure the image covers the entire section
          backgroundPosition: "center", // Center the background image
          backgroundRepeat: "no-repeat", // Prevent repeating the background
          // maxWidth: 1920,
          margin: "auto",
        }}
      >
        <div ref={ref7} className="xl:flex gap-10 justify-center max-w-7xl">
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={isInView7 ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="xl:w-[2400px] xl:h-[664px]"
          >
            <img src={"/images/penside.png"} className="h-full w-full hidden xl:block" />
          </motion.div>
          <div>
            <div className="flex justify-center lg:hidden mt-10 xl:-ml-16 px-2 xl:px-0">
              <h6 className=" bg-custom-radial bg-clip-text text-transparent font-aileron text-[32px] xl:text-[38px] text-[#49378F] font-bold text-center xl:text-start">
                Network Security Services
              </h6>
            </div>
            <div className=" mt-10 xl:-ml-16 px-6 xl:px-0">
              <h6 className=" bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] xl:text-[38px] text-[#49378F] font-bold text-center xl:text-start mb-4">
                {blok.contentText19}
              </h6>
              <p className="font-lato text-[18px] mx-auto xl:mx-0 text-center xl:text-start">
                {blok.contentText20}
              </p>
            </div>
            <div className=" mt-10  px-6 xl:px-0">
              <h6 className=" bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] xl:text-[38px] text-[#49378F] font-bold text-center xl:text-start mb-4">
                {blok.contentText21}
              </h6>
              <p className="font-lato text-[18px] mx-auto lg:mx-0 text-center xl:text-start">
                {blok.contentText22}
              </p>
            </div>
            <div className="xl:-ml-24 mt-10  px-6 2xl:px-0">
              <h6 className=" bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] xl:text-[38px] text-[#49378F] font-bold text-center xl:text-start mb-4">
                {blok.contentText23}
              </h6>
              <p className="font-lato text-[18px]  mx-auto xl:mx-0 text-center xl:text-start">
                {blok.contentText24}
              </p>
            </div>
          </div>
        </div>


        <div className="lg:flex justify-center mt-20 max-w-7xl">
          <h6 className=" px-6 xl:px-0 bg-custom-radial bg-clip-text text-transparent font-aileron text-[28px] lg:text-[48px] text-[#49378F] font-bold text-center lg:text-start">
            {blok.contentText33}
          </h6>
        </div>
        <div
          ref={ref8}
          className="grid grid-cols-1 xl:grid-cols-2 gap-20 md:gap-16 lg:gap-20 mt-24
            md:mt-16 lg:mt-28 md:max-w-[90%] lg:max-w-[1200px] mx-auto mb-10 lg:mb-40  max-w-7xl  px-6 xl:px-0"
        >
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={isInView8 ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <InfoBox
              icon={blok.contentImage5.filename}
              heading={blok.contentText25}
              description={blok.contentText26}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={isInView8 ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <InfoBox
              icon={blok.contentImage6.filename}
              heading={blok.contentText27}
              description={blok.contentText28}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={isInView8 ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <InfoBox
              icon={blok.contentImage7.filename}
              heading={blok.contentText29}
              description={blok.contentText30}
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={isInView8 ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <InfoBox
              icon={blok.contentImage8.filename}
              heading={blok.contentText31}
              description={blok.contentText32}
            />
          </motion.div>
        </div>
      </div>
      <div className="bg-[#EFEBFB]">
        <div className=" space-y-6 ">
          <ResourcesSection
            calenderIcon={blok.calenderIcon.filename}
            blok={blok}
          />
          <div>
            <LevelUpAndTrustSection certiReqd={true} blok={blok} levelUpRef={levelUpRef} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PenetrationTesting